import React, {FC, useContext} from 'react';
import firebase from "firebase/app";
import {useHistory, useLocation} from 'react-router-dom';
import {Button, Container, CssBaseline, makeStyles, TextField, Typography} from "@material-ui/core";
import {AuthContext} from "./AuthProvider";
import {AuthService} from "../redux/Auth.service";
import {useLogout} from "../redux/auth.hook";
import logo_green from "../../orderEngine/logo_green.png";

const useStyles = makeStyles((theme) => ({
    paper: {
       /* marginTop: theme.spacing(8),*/
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%'
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const authService = new AuthService();

export const LogInScreen: FC<unknown> = () => {

    const classes = useStyles();
    const history = useHistory();
    const location = useLocation<{ from: string }>();
    const {logout} = useLogout();

    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');

    const [, setLoading] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);
    const {setAuth} = useContext(AuthContext);

    React.useEffect(() => {
        return firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                authService.getUserAuthorization(user.uid)
                    .then(authorization => {
                        setAuth(user.uid, authorization.role);
                        localStorage.setItem('userId', user.uid)
                        localStorage.setItem('userRole', authorization.role)

                        const firstScreen = authorization.role === 'admin' ? '/calendar' : ''

                        const {from} = location.state || {from: {pathname: `/${authorization.role}${firstScreen}`}};
                        history.replace(from);
                    })
                    .catch(() => {
                        logout();
                    })
            }
        });
    }, [history, location.state, logout, setAuth]);

    const doLogIn = () => {
        setLoading(true);
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(() => {
                setError(null);
            })
            .catch((error) => {
                setError(error.message);
            });
    };

    return (
        <Container component="main" maxWidth="xs"
                   style={{height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", margin: "auto"}}>
            <CssBaseline/>
            <img style={{
                maxHeight: 100,
                marginBottom: 16
            }} alt="logo" src={logo_green}/>
            <div className={classes.paper}>
                {/*<Typography component="h1" variant="h4" color="primary" style={{margin: 20}}>
                    Login
                </Typography>*/}
                <form className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        onChange={(event) => setEmail(event.target.value)}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        onChange={(event) => setPassword(event.target.value)}
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={doLogIn}
                    >
                        Sign In
                    </Button>
                </form>
            </div>
            {error && <Typography color="error">{error}</Typography>}
        </Container>
    );
}
